<template>
    <div>
        <div class="w-full md:w-4/5 m-auto py-6 px-12">
            <div v-if="loading" class="lds-spinner">
                <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
            </div>
            <h1 class="mb-4 text-lshtm-primary text-2xl text-left font-bold text-2xl">Manage Your Applications</h1>
            <div class="flex flex-wrap bg-gray-100 border px-4 py-1 mt-1 pb-6">
                <div class="w-full text-left py-4 relative flex flex-wrap">
                    <div class="w-full mb-2 text-sm"><span v-if="loading">Fetching your applications...</span><span v-else /></div>
                </div>
                <div class="w-full flex flex-col items-center -mt-6" style="display: none;">
                    <div class="m-4 flex justify-end">
                        <router-link :to="{ name: 'Home'}">
                            <button class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Start another application</button>
                        </router-link>
                    </div>
                </div>
                <div class="w-full">
                    <div v-for="(applications, title) in applicationsByType" :key="title" class="w-full">
                        <div class="bg-white border text-left border-gray-300 flex flex-wrap mb-4 p-8">
                            <div class="w-full md:w-1/2 divide-y divide-grey-400">
                                <div class="p-1 font-extrabold">{{ title }}</div>
                            </div>

                            <div class="w-full">
                                <table class="w-full table-auto">
                                    <thead>
                                        <tr>
                                            <th>Reference</th>
                                            <th>Status</th>
                                            <th>Programme Name</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(application) in applications" :key="application.reference">
                                            <td class="w-1/5">{{ application.user.data.stucode }}</td>
                                            <td class="w-1/5">{{ application.public_status }}</td>
                                            <td class="w-1/5">{{ application.programmeName }}</td>
                                            <td class="w-2/5 text-xs">
                                                <div class="w-full pt-4">
                                                    <div v-if="application.can_edit_referees && application.num_references_required > 0" class="m-2 float-start">
                                                        <router-link :to="{ name: 'EditReferees',params:{id:application.reference} }">
                                                            <button class="bg-lshtm-primary hover:bg-lshtm-primary text-white rounded py-2 px-4">Referees and References</button>
                                                        </router-link>
                                                    </div>

                                                    <div class="m-2 float-start">
                                                        <router-link v-if="application.status !== 'Draft'" :to="{ name: 'ReviewApplication',params:{id:application.reference} }">
                                                            <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white rounded py-2 px-4">Review</button>
                                                        </router-link>
                                                    </div>

                                                    <div v-if="application.status === 'Draft'" class="m-2 float-start">
                                                        <router-link :to="{ name: 'EditApplication',params:{id:application.reference} }">
                                                            <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white rounded py-2 px-4">Edit</button>
                                                        </router-link>
                                                    </div>

                                                    <div v-if="application.status === 'Offered' || application.status === 'Offered, Registry Review (on hold)'"
                                                         class="m-2 float-start"
                                                    >
                                                        <router-link :to="{ name: 'ApplicationDecision', params:{id:application.reference} }">
                                                            <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Respond to offer</button>
                                                        </router-link>
                                                    </div>
                                                    <div v-if="application.status === 'Awaiting Deposit'" class="m-2 float-start">
                                                        <router-link :to="{ name: 'ApplicationDecision', params: { id: application.reference }}">
                                                            <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">View offer conditions</button>
                                                        </router-link>
                                                    </div>
                                                </div>


                                                <div class="mt-8 w-full">
                                                    <h2 v-if="application?.hasDocumentRequest" class="mb-2">Additional documentation is required from you, open the application to respond.</h2>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div v-for="(applicationGroup) in applicationGroups?.data" :key="applicationGroup.reference" class="w-full">
                        <div class="bg-white border text-left border-gray-300 flex flex-wrap mb-4 p-8">
                            <div class="w-full md:w-1/2 divide-y divide-grey-400">
                                <div class="p-1 font-extrabold">{{ applicationGroup.title ?? 'Grouped Application' }}</div>
                                <!-- <div class="p-1">Group Status</div> -->
                                <div class="p-1">Academic Year</div>
                                <div class="p-1">Programme Type</div>
                            </div>
                            <div class="w-full md:w-1/2 divide-y divide-grey-400">
                                <div class="p-1 text-right">
                                    <router-link :to="{ name: 'EditChoices',params:{id: applicationGroup.primaryApplication} }">
                                        <button class="bg-yellow-700 hover:bg-info-400 text-white rounded py-2 px-4">Add new course/module</button>
                                    </router-link>
                                </div>
                                <div class="p-1">
                                    <p v-if="applicationGroup.academicYear">{{ applicationGroup.academicYear }}</p>
                                    <p v-else>&nbsp;</p>
                                </div>
                                <div class="p-1">
                                    <p v-if="applicationGroup.programmeType">{{ applicationGroup.programmeType }}</p>
                                    <p v-else>&nbsp;</p>
                                </div>
                                <div class="p-1">{{ applicationGroup.programmeName }}</div>
                            </div>
                            <h3 class="font-bold mt-2 mb-2 focus-here-on-success">List of Courses / Modules</h3>
                            <div class="w-full text-left py-4 relative flex flex-wrap">
                                <div class="w-full mb-2 text-sm"><span v-if="successMessage === 'Programme details updated'" class="text-green-500"><b>New Programme Added</b></span></div>
                            </div>
                            <div class="w-full">
                                <table class="w-full table-auto">
                                    <thead>
                                        <tr>
                                            <th>Reference</th>
                                            <th>Status</th>
                                            <th>Programme Name</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(application) in applicationGroup.applications.data" :key="application.reference">
                                            <td>{{ applicationGroup.user.data.stucode }}</td>
                                            <td>{{ application.public_status }}</td>
                                            <td>{{ application.programmeName }}</td>
                                            <td class="w-1/3 text-xs">
                                                <div class="w-full pt-4">
                                                    <div v-if="application.can_edit_referees && application.num_references_required > 0" class="m-2 float-start">
                                                        <router-link :to="{ name: 'EditReferees',params:{id:application.reference} }">
                                                            <button class="bg-lshtm-primary hover:bg-lshtm-primary text-white rounded py-2 px-4">Referees and References</button>
                                                        </router-link>
                                                    </div>

                                                    <div class="m-2 float-start">
                                                        <router-link v-if="application.status !== 'Draft'" :to="{ name: 'ReviewApplication',params:{id:application.reference} }">
                                                            <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white rounded py-2 px-4">Review</button>
                                                        </router-link>
                                                    </div>

                                                    <div v-if="application.status === 'Draft' && (applicationGroup.primaryApplication === null || application.is_group_primary)" class="m-2 float-start">
                                                        <router-link :to="{ name: 'EditApplication',params:{id:application.reference} }">
                                                            <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white rounded py-2 px-4">Edit</button>
                                                        </router-link>
                                                    </div>

                                                    <div v-if="application.status === 'Offered' || application.status === 'Offered, Registry Review (on hold)'"
                                                         class="m-2 float-start"
                                                    >
                                                        <router-link :to="{ name: 'ApplicationDecision', params:{id:application.reference} }">
                                                            <button v-if="application.reference" class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-2 px-4 rounded">Respond to offer</button>
                                                        </router-link>
                                                    </div>
                                                    <div v-if="application.status === 'Awaiting Deposit'" class="m-2 float-start">
                                                        <router-link :to="{ name: 'ApplicationDecision', params: { id: application.reference }}" class="bg-lshtm-primary">View offer conditions</router-link>
                                                    </div>
                                                </div>


                                                <div class="mt-8 w-full">
                                                    <h2 v-if="application?.hasDocumentRequest" class="mb-2">Additional documentation is required from you, open the application to respond.</h2>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Application',
    metaInfo() {
        return {
            title: 'Application',
        }
    },
    components: {
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.previousRoute = from
        })
    },
    data() {
        return {
            form: ({
                reference: '',
                documentRequestReference: '',
                document_type: null,
                file: null,
            }),
            applicationData: [],
            applicationGroupData: [],
            loading: true,
            successMessage: '',
            fromEditChoices: false,
            previousRoute: null, 
            serverError: '',

        }
    },
    computed: {
        applicationDetails() {
            return this.$store.getters.applicationDetails
        },
        applicationGroups() {
            return this.$store.getters.applicationGroups
        },
        applicationsByType() {
            let data = []
            if (this.applicationData.data) {
                data = JSON.parse(JSON.stringify(this.applicationData.data))
            }

            data = data.sort((a, b) => {
                if (!a.academicYear || !a.programmeType) {
                    return 1
                }

                if (!b.academicYear || !b.programmeType) {
                    return -1
                }

                return b.academicYear.localeCompare(a.academicYear) || a.programmeType.localeCompare(b.programmeType)
            })

            return this.groupByType(data)
        },
    },
    watch: {
        applicationDetails(data) {
            this.applicationData = data
            this.hasLoaded()
        },
      applicationGroups(data) {
        this.applicationGroupData = data
        this.hasLoaded()
      },
    },
    mounted() {
        this.fromEditChoices = this.previousRoute?.path.includes('/EditChoices')
    },
    created() {
        this.$store.dispatch('retrieveApplications')
            .then(() => {
              this.$toast.show('Applications refreshed')
            })
            .catch(() => {
            })
    },
    methods: {
        create() {
            this.loading = true
            this.$store.dispatch('createApplication')
                .then(() => {
                    window.location.reload(true)
                })
                .catch(() => {

                })
        },
        update() {
            this.loading = true
            const formData = new FormData()
            formData.append('file', this.form.file)
            formData.append('reference', this.form.reference)
            formData.append('document_request_reference', this.form.documentRequestReference)
            formData.append('document_type', this.form.document_type)
            this.$store.dispatch('uploadDocument', {
                applicationRef: this.form.reference,
                file: formData,
            })
                .then((response) => {
                    this.loading = false
                    this.successMessage = response.data
                    this.serverError = ''
                    location.reload()
                })
                .catch(error => {
                    this.loading = false
                    this.successMessage = ''
                    this.serverError = error.response.data.errors.file[0]
                })
        },
        hasLoaded() {
            this.loading = false
            if (this.$route.query.successMessage && this.fromEditChoices) {
                this.displaySuccessMessage(this.$route.query.successMessage)
            }
        },
        dirtyForm(applicationReference, reference) {
            this.form.reference = applicationReference
            this.form.documentRequestReference = reference
            this.formDirty = true
            this.successMessage = ''
        },
        displaySuccessMessage(message) {
            this.$nextTick(() => {
            const coursesSection = this.$el.querySelector('h3.focus-here-on-success')
            if (coursesSection) {
                coursesSection.scrollIntoView({ behavior: 'smooth' })
                }
            })
            this.successMessage = message
            setTimeout(() => {
                this.successMessage = null
            }, 6000)
        },
        groupByType(applications) {
            return applications.reduce((data, application) => {
                let key = `${application.academicYear? application.academicYear : 'N/A'} ${application.programmeType? application.programmeType : 'N/A'} Applications`
                if (!data[key]) {
                    data[key] = []
                }
                data[key].push(application)

                return data
            }, {})
        },
    },
}
</script>
